
    import './styles.scoped.css';
    export default {
  "day": "awsui_day_vci2l_1fdgl_93",
  "day-inner": "awsui_day-inner_vci2l_1fdgl_117",
  "in-first-row": "awsui_in-first-row_vci2l_1fdgl_141",
  "in-previous-month": "awsui_in-previous-month_vci2l_1fdgl_141",
  "last-day-of-month": "awsui_last-day-of-month_vci2l_1fdgl_145",
  "in-next-month": "awsui_in-next-month_vci2l_1fdgl_149",
  "in-first-column": "awsui_in-first-column_vci2l_1fdgl_153",
  "in-current-month": "awsui_in-current-month_vci2l_1fdgl_156",
  "enabled": "awsui_enabled_vci2l_1fdgl_160",
  "in-range": "awsui_in-range_vci2l_1fdgl_166",
  "end-date": "awsui_end-date_vci2l_1fdgl_166",
  "start-date": "awsui_start-date_vci2l_1fdgl_166",
  "no-range": "awsui_no-range_vci2l_1fdgl_166",
  "selected": "awsui_selected_vci2l_1fdgl_173",
  "today": "awsui_today_vci2l_1fdgl_177",
  "range-start-date": "awsui_range-start-date_vci2l_1fdgl_213",
  "in-range-border-bottom": "awsui_in-range-border-bottom_vci2l_1fdgl_216",
  "range-end-date": "awsui_range-end-date_vci2l_1fdgl_219",
  "in-range-border-top": "awsui_in-range-border-top_vci2l_1fdgl_222",
  "in-range-border-right": "awsui_in-range-border-right_vci2l_1fdgl_237",
  "in-range-border-left": "awsui_in-range-border-left_vci2l_1fdgl_243"
};
  